import { noop } from '@philips-emr/tws-utils';

import { Mountable } from '../types';

import EventData from './event-data';

interface EventCallback<DT> {
  (event: DT): void;
}

class EventBus<ED extends EventData<Mountable>> extends Map<string, EventCallback<ED>[]> {

  get(key: string): EventCallback<ED>[]|undefined {
    if (!this.has(key)) {
      this.set(key, []);
    }
    return super.get(key);
  }

  insert(key: string, callback: EventCallback<ED>): Function {
    const set = this.get(key);

    if (set) {
      set.push(callback);
      return () => {
        const i  = set.indexOf(callback);
        set.splice(i, 1);
      };
    }
    return noop;
  }

}

export default EventBus;
